<template>
    <div>
        <gofix-card title="General Information" classHeader="mb-2" classContent="position-relative">
            <b-row>
                <b-col md="4">
                    <dropdown-projects
                        required
                        show-icon-required
                        :disabled="isDisabledEdit"
                        v-model="info.project"
                        @change="changeProject">
                    </dropdown-projects>
                </b-col>
                <b-col md="4">
                    <dropdown-locations 
                        label="Location"
                        required
                        show-icon-required
                        :disabled="isDisabledEdit"
                        :project-id="info.project && info.project.id ? info.project.id : null"
                        v-model="info.equipment">
                    </dropdown-locations>
                </b-col>
                <b-col md="4">
                    <gofix-form-input 
                        disabled
                        label="Status" 
                        v-model="info.status">
                    </gofix-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="4">
                    <gofix-form-input-date
                        :minDate="new Date()"
                        required
                        show-icon-required
                        :disabled="isDisabledEdit"
                        v-model="info.planned_date"
                        label="Date">
                    </gofix-form-input-date>
                </b-col>
                <b-col md="2">
                    <gofix-form-input-time 
                        label="Start Time" 
                        required
                        show-icon-required
                        :disabled="isDisabledEdit"
                        v-model="info.start_time">
                    </gofix-form-input-time>
                </b-col>
                <b-col md="2">
                    <gofix-form-input-time 
                        label="End Time" 
                        required
                        show-icon-required
                        :disabled="isDisabledEdit"
                        v-model="info.end_time">
                    </gofix-form-input-time>
                </b-col>
                <b-col md="4">
                    <dropdown-companies 
                        :project-id="info.project && info.project.id ? info.project.id : null"
                        required
                        show-icon-required
                        :disabled="isDisabledEdit"
                        v-model="info.supplier">
                    </dropdown-companies>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="8">
                    <gofix-form-dropdown 
                        label="Topics" 
                        vLabel="reference_value_text"
                        required
                        show-icon-required
                        multiple
                        :disabled="info.status && info.status == 'Submitted'"
                        v-model="info.topics" 
                        :options="options.topics">
                    </gofix-form-dropdown>
                </b-col>
                <b-col md="4">
                    <!-- <dropdown-user-duties 
                        :project-id="info.project && info.project.id ? info.project.id : null"
                        :company-id="info.supplier && info.supplier.id ? info.supplier.id : null"
                        required 
                        show-icon-required
                        :disabled="isDisabledEdit"
                        role-name="Contractor Supervisor"
                        v-model="info.contractor_supervisor_by">
                    </dropdown-user-duties> -->
                    <gofix-form-input 
                        disabled
                        label="Subcontractor Supervisor" 
                        v-model="info.created_by_name">
                    </gofix-form-input>
                </b-col>
            </b-row>
            <!-- <b-row>
                <b-col md="8">
                    <dropdown-locations 
                        label="Locations"
                        required
                        show-icon-required
                        multiple
                        :disabled="isDisabledEdit"
                        :project-id="info.project && info.project.id ? info.project.id : null"
                        v-model="info.locations">
                    </dropdown-locations>
                </b-col>
            </b-row> -->
            <b-row>
                <b-col md="4">
                    <gofix-form-input 
                        disabled
                        label="GPS Location" 
                        v-model="info.gps_location">
                    </gofix-form-input>
                </b-col>
                <b-col md="4">
                    <dropdown-user-duties 
                        label="Property Manager"
                        :disabled="isDisabledEdit"
                        :project-id="info.project && info.project.id ? info.project.id : null"
                        role-name="TC - Property Mgr (AGM/SPM/PM)"
                        :safetyOnlyFM="true"
                        v-model="info.property_manager_by">
                    </dropdown-user-duties>
                </b-col>
                <b-col md="4">
                    <dropdown-user-duties 
                        label="Safety Officer"
                        :disabled="isDisabledEdit"
                        :project-id="info.project && info.project.id ? info.project.id : null"
                        role-name="Safety Officer"
                        :safetyOnlyFM="true"
                        v-model="info.safety_officer_by">
                    </dropdown-user-duties>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="8">
                    <gofix-form-input-textarea 
                        label="Comment" 
                        :rows="10" 
                        :disabled="!isAllowComment"
                        v-model="info.comment_cs.description">
                    </gofix-form-input-textarea>
                </b-col>
            </b-row>
        </gofix-card>
        <b-row>
            <b-col md="12">
                <gofix-card title="Approval Information" classContent="position-relative pr-83">
                    <b-row class="mb-16">
                        <b-col md="4">
                            <gofix-text-field class-label="width-120" label="Submitted Date" oneline>{{ info.submitted_at ? $options.filters.formatDatebyMoment(info.submitted_at, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                        </b-col>
                        <b-col md="4">
                            <gofix-text-field class-label="width-120" label="Submitted By" oneline>{{ info.submitted_by && info.submitted_by.name ? info.submitted_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                    <b-row v-if="info.status && info.status == 'Rejected'">
                        <b-col md="4">
                            <gofix-text-field class-label="width-120" label="Rejected Date" oneline>{{ Item.rejected_at ? $options.filters.formatDatebyMoment(Item.rejected_at, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                        </b-col>
                        <b-col md="4">
                            <gofix-text-field class-label="width-120" label="Rejected By" oneline>{{ Item.rejected_by && Item.rejected_by.name ? Item.rejected_by.name : '' }}</gofix-text-field>
                        </b-col>
                        <b-col md="4">
                            <gofix-text-field label="Reason" oneline>{{ Item.reason_reject }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </gofix-card>

                <gofix-card title="Photos" classHeader="mb-2" classContent="position-relative pr-83">
                    <b-row align-v="center" class="mt-3">
                        <b-col md="12">
                            <p class="mb-2">(Attach Photograph / Drawings)</p>
                            <div>
                                <div v-if="info.photos && info.photos.length" class="photosThumb photosThumb-safety mt-0 mb-0">
                                    <viewer-image :images="info.photos">
                                        <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                            <ul class="list-thumb mb-2">
                                                <template v-for="(item, key) in info.photos">
                                                    <li :key="key">
                                                        <img v-auth-image="item.url.medium" alt  src="img/loading.gif"/>
                                                        <span class="delete" v-if="$checkRole($accessModule.toolbox_meeting, 'update') && info && info.id && ['New'].includes(info.status)" @click.stop="deleteFile(item)">
                                                            <img src="img/close.png" alt />
                                                        </span>
                                                    </li>
                                                </template>
                                            </ul>
                                        </template>
                                    </viewer-image>
                                </div>
                                <div class="upload-btn-wrapper ml-0 mt-0 d-block" v-if="info && info.id && ['New'].includes(info.status)">
                                    <b-form-file id="fileInputMulti" v-model="attachment.files" :plain="true" :multiple="true"></b-form-file>
                                    <gofix-button class="icon-svg icon-svg-left mb-2" label="Upload" outline v-if="$checkRole($accessModule.toolbox_meeting, 'update')">
                                        <template slot="gofix:button:beforeLabel">
                                            <span class="icon mr-2">
                                                <svg width="23" height="19" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11.6537 8.20604C11.6355 8.1827 11.6121 8.16382 11.5855 8.15083C11.5588 8.13785 11.5296 8.1311 11.4999 8.1311C11.4703 8.1311 11.441 8.13785 11.4144 8.15083C11.3877 8.16382 11.3644 8.1827 11.3461 8.20604L8.61175 11.6655C8.58921 11.6943 8.57522 11.7288 8.57139 11.7652C8.56755 11.8016 8.57403 11.8383 8.59007 11.8711C8.60612 11.904 8.63108 11.9317 8.66212 11.951C8.69315 11.9703 8.72899 11.9805 8.76556 11.9805H10.5698V17.8984C10.5698 18.0058 10.6576 18.0937 10.7651 18.0937H12.2299C12.3373 18.0937 12.4252 18.0058 12.4252 17.8984V11.9829H14.2343C14.3979 11.9829 14.4882 11.7949 14.3881 11.668L11.6537 8.20604Z" fill="#F05600" />
                                                    <path d="M18.8096 5.95264C17.6914 3.00342 14.8423 0.90625 11.5049 0.90625C8.16748 0.90625 5.31836 3.00098 4.2002 5.9502C2.10791 6.49951 0.5625 8.40625 0.5625 10.6719C0.5625 13.3696 2.74756 15.5547 5.44287 15.5547H6.42188C6.5293 15.5547 6.61719 15.4668 6.61719 15.3594V13.8945C6.61719 13.7871 6.5293 13.6992 6.42188 13.6992H5.44287C4.62012 13.6992 3.84619 13.3721 3.27002 12.7788C2.69629 12.188 2.39111 11.3921 2.41797 10.5669C2.43994 9.92236 2.65967 9.31689 3.05762 8.80664C3.46533 8.28662 4.03662 7.9082 4.67139 7.73975L5.59668 7.49805L5.93604 6.60449C6.146 6.04785 6.43896 5.52783 6.80762 5.05664C7.17156 4.58962 7.60267 4.17908 8.08691 3.83838C9.09033 3.13281 10.272 2.75928 11.5049 2.75928C12.7378 2.75928 13.9194 3.13281 14.9229 3.83838C15.4087 4.18018 15.8384 4.59033 16.2021 5.05664C16.5708 5.52783 16.8638 6.05029 17.0737 6.60449L17.4106 7.49561L18.3335 7.73975C19.6567 8.09619 20.582 9.2998 20.582 10.6719C20.582 11.48 20.2671 12.2417 19.6958 12.813C19.4156 13.0948 19.0823 13.3182 18.7152 13.4703C18.3481 13.6225 17.9545 13.7003 17.5571 13.6992H16.5781C16.4707 13.6992 16.3828 13.7871 16.3828 13.8945V15.3594C16.3828 15.4668 16.4707 15.5547 16.5781 15.5547H17.5571C20.2524 15.5547 22.4375 13.3696 22.4375 10.6719C22.4375 8.40869 20.897 6.5044 18.8096 5.95264Z" fill="#F05600" />
                                                </svg>
                                            </span>
                                        </template>
                                    </gofix-button>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </gofix-card>
            </b-col>
        </b-row>
        <b-modal :no-close-on-backdrop="true" id="modal-bacsicInfo" title="Next Action" hide-footer :centered="true" v-model="modals.bacsicInfo.open">
            <b-form class="pb-10">
                <template>
                    <gofix-form-dropdown 
                        label="Status" 
                        vLabel="name" 
                        :filterable="false" 
                        v-model="modals.bacsicInfo.data.status" 
                        :options="jobOptionStatus">
                    </gofix-form-dropdown>
                </template>
                <gofix-form-input-textarea 
                    v-if="modals.bacsicInfo.data.status == 'Rejected'"
                    label="Reason for Rejection"
                    v-model="modals.bacsicInfo.data.activity_remark" 
                    showIconRequired 
                    required>
                </gofix-form-input-textarea>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="updateBasicInfo" :loading="modals.bacsicInfo.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    const ViewerImage = () => import('../../plugins/ViewerImage.vue')
    import DropdownProjects from '../elements/DropdownProjects.vue'
    import DropdownLocations from '../elements/DropdownLocations.vue'
    import DropdownCompanies from '../elements/DropdownCompanies.vue'
    import DropdownUserDuties from '../elements/DropdownUserDuties.vue'
    
    export default {
        name: 'safety-inspection-checklist-detail-info',
        components: {
            ViewerImage,
            DropdownProjects,
            DropdownLocations,
            DropdownCompanies,
            DropdownUserDuties
        },
        data() {
            return {
                localHref : window.location.origin,
                info: {
                    id: null,
                    project: null,
                    equipment: null,
                    status: null,
                    planned_date: null,
                    start_time: null,
                    end_time: null,
                    supplier: null,
                    topics: null,
                    // contractor_supervisor_by: null,
                    gps_location: null,
                    property_manager_by: null,
                    safety_officer_by: null,
                    comment_cs: {
                        id: null,
                        description: null,
                        type: "comment_cs"
                    },
                    submitted_at: null,
                    submitted_by: null,
                    photos: null,
                    client_contract_id: null,
                    schedule_training_date: null,
                    schedule_training_venue: null,
                    schedule_training_trade: null,
                    schedule_training_company: null,
                    created_by_name: null,
                    created_by_name: null
                },
                options: {
                    topics: [],
                },
                modals: {
                    bacsicInfo: {
                        open: false,
                        loading: false,
                        data: {
                            status: null,
                            completed_by_id: null,
                            accepted_by_id: null,
                            started_by_id: null,
                            completed_at: null,
                            completed_at_hour: null,
                            accepted_at: null,
                            accepted_at_hour: null,
                            started_at: null,
                            started_at_hour: null,
                            activity_remark: null
                        }
                    },
                },
                option_status: {
                    'New': ['Submitted'],
                    'Submitted': ['Rejected'],
                    'Rejected': ['Submitted'],                  
                },
                attachment: {
                    items: [],
                    files: [],
                },
            }
        },
        computed: {
            ...mapGetters({
                User : 'AuthController/user',
                Item: 'SafetyAppController/safetyJob',
            }),
            jobOptionStatus() {
                return this.option_status[this.Item.status];
            },
            isDisabledEdit() {
                return ['Submitted', 'Rejected'].includes(this.info.status);
            },
            isAllowComment() {
                let flag = false
                if (this.UserLogin && this.UserLogin.roles && this.UserLogin.roles.length > 0) {
                    for (let i = 0; i < this.UserLogin.roles.length; i++) {
                        if (this.UserLogin.roles[i].name === 'Contractor Supervisor') {
                            flag = true;
                            break;
                        }
                    }
                }
                return !this.isDisabledEdit && flag;
            }
        },
        watch: {
            Item: function(val) {
                this.setValue();
            },
             "attachment.files": function(val, old) {
                if (val) {
                    val.forEach((file) => {
                        if (
                            file.type != "image/jpeg" &&
                            file.type != "image/png" &&
                            file.type != "image/gif"
                        ) {
                            this.$alertNotification("File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!", "warning");
                            return;
                        }
                        file.moment = moment().valueOf();
                        let data = {
                            moment: moment().valueOf(),
                            url: {
                                original: URL.createObjectURL(file),
                                medium: URL.createObjectURL(file),
                                thumb: URL.createObjectURL(file),
                            }
                        };
                        this.attachment.items.push(file);
                        this.info.photos.push(data);
                    });
                }
                
            },
        },
        created() {
            this.setValue();
            this.getTopics();
        },
        methods: {
            async setValue() {
                if(this.Item && this.Item.id && this.$route.params.id == this.Item.id) {
                    const obj = JSON.parse(JSON.stringify(this.Item))
                    this.info = Object.assign(this.info, {
                        id: obj.id,
                        project: obj.project,
                        equipment: obj.location_id ? {
                            id: obj.location_id,
                            // equipment_lift_number: obj.equipment_lift_number,
                            // equipment_id: obj.equipment_id,
                            name: obj.location,
                            location_id: obj.location_id,
                            // equipment_type: obj.equipment_type,
                        } : null,
                        status: obj.status,
                        planned_date: new Date(obj.planned_date),
                        start_time: obj.start_time,
                        end_time: obj.end_time,
                        supplier: obj.supplier_id && obj.supplier ? {
                            id: obj.supplier_id,
                            name: obj.supplier
                        } : null,
                        topics: obj.topics,
                        /*contractor_supervisor_by: obj.contractor_supervisor_by ? {
                            user_id: obj.contractor_supervisor_id,
                            user_name: obj.contractor_supervisor_by.name,
                            user_email: obj.contractor_supervisor_by.email
                        } : null,*/
                        gps_location: obj.gps_location,
                        property_manager_by: obj.property_manager_by ? {
                            user_id: obj.property_manager_id,
                            user_name: obj.property_manager_by.name,
                            user_email: obj.property_manager_by.email
                        } : null,
                        safety_officer_by: obj.safety_officer_by ? {
                            user_id: obj.safety_officer_id,
                            user_name: obj.safety_officer_by.name,
                            user_email: obj.safety_officer_by.email
                        } : null,
                        comment_cs: obj.comment_cs ? {
                            id: obj.comment_cs.id,
                            description: obj.comment_cs.description,
                            type: obj.comment_cs.type,
                        } : {
                            id: null,
                            description: null,
                            type: "comment_cs"
                        },
                        submitted_at: obj.submitted_at,
                        submitted_by: obj.submitted_by,
                        photos: obj.photos,
                        client_contract_id: obj.client_contract_id,
                        schedule_training_date: obj.schedule_training_date ? new Date(obj.schedule_training_date) : null,
                        schedule_training_venue: obj.schedule_training_venue,
                        schedule_training_trade: obj.schedule_training_trade,
                        schedule_training_company: obj.schedule_training_company,
                        created_by_name: obj.created_by_name
                    });

                    // callback Contract selector
                    if(this.info && this.info.client_contract_id && (!this.ClientContractID || !this.ClientContractID.id || (this.ClientContractID && this.ClientContractID.id && this.ClientContractID.id != this.info.client_contract_id))) {
                        await this.$store.dispatch( 'ContractController/getClientContractID', this.info.client_contract_id).then(response => {
                            localStorage.setItem("ClientContractID", JSON.stringify(response.data.data));
                        })
                    }
                }
            },
            getTopics(){
                let filter = {reference_type: "Safety Toolbox Meeting Topics"};
                let params = {
                    filter: filter,
                    limit: -1,
                    sortColumn: "id",
                    sortDirection: "asc",
                };
                this.$store.dispatch(`ReferenceController/getItems`, params)
                    .then(response => {
                        this.options.topics = response.items;
                    })
            },
            showModalTraning() {
                this.modals.training.data = {
                    schedule_training_date: new Date(this.info.schedule_training_date),
                    schedule_training_venue: this.info.schedule_training_venue,
                    schedule_training_trade: this.info.schedule_training_trade,
                    schedule_training_company: this.info.schedule_training_company,
                }
                this.modals.training.open = true;
            },

            /*-- Get Data --------*/
            editBacsicInfo() {
                this.modals.bacsicInfo.data = Object.assign(this.modals.bacsicInfo.data, {
                    status: null,
                    submitted_by_id: this.Item.submitted_by_id,
                    submitted_at: this.Item.submitted_at ? new Date(this.Item.submitted_at) : null,
                    submitted_at_hour: this.Item.submitted_at ? moment(new Date(this.Item.submitted_at)).format("HH:mm") : null,
                });
                this.modals.bacsicInfo.open = true;
            },
            async updateBasicInfo() {
                if(!this.modals.bacsicInfo.data.status) {
                    return this.$alertNotification("Please select status", "danger");
                }

                if(this.modals.bacsicInfo.data.status == 'Rejected' && !this.modals.bacsicInfo.data.activity_remark) {
                    return this.$alertNotification("Please enter reason for rejection", "danger");
                }
                

                if (this.modals.bacsicInfo.loading) return;
                this.modals.bacsicInfo.loading = true;

                let params = this.processJob(this.modals.bacsicInfo.data);
                if(params === false) return

                // if(this.modals.bacsicInfo.data.status == 'Rejected') params.reason_reject = this.modals.bacsicInfo.data.reason_reject
                this.changeStatus(params);
            },
            changeStatus(params) {
                this.$store
                    .dispatch("SafetyAppController/updateSafetyStatus", {
                        data: params,
                        id: this.Item.id,
                    })
                    .then((result) => {
                        this.$alertNotification(this.$notificationV2("editing", "toolbox_meeting"));
                        this.modals.bacsicInfo.loading = false;
                        this.modals.bacsicInfo.open = false;
                        this.$emit("reloadItem");
                    })
                    .catch((err) => {
                        this.modals.bacsicInfo.loading = false;
                        if(err.response.data.error.message.error){
                            return this.$alertNotification(err.response.data.error.message.error, "danger");
                        }
                    });
            },
            processJob(data) {
                let status = data.status.toLowerCase();
                const defaultStatus = {
                    'submitted': {
                        status: 'Submitted',
                        submitted_by_id: data.submitted_by_id || null,
                        submitted_at: null,
                    },
                    'rejected': {
                        status: 'Rejected',
                        rejected_by_id: data.rejected_by_id || null,
                        rejected_at: null,
                        activity_remark: data.activity_remark || null,
                    },
                };
                

                const obj = defaultStatus[status];

                // if(!obj[`${status}_by_id`]) {
                //     this.$alertNotification(`Please select ${obj.status} By`, "danger");
                //     return false
                // }

                if (data[`${status}_at`]) {
                    obj[`${status}_at`] = moment(new Date(data[`${status}_at`])).format("YYYY-MM-DD");
                }

                if (data[`${status}_at_hour`]) {
                    obj[`${status}_at`] = obj[`${status}_at`] + ' ' + data[`${status}_at_hour`] + ":00";
                }

                return obj
            },
            deleteFile(img) {
                if (img.moment) {
                    this.attachment.items = this.attachment.items.filter(
                        (item) => item.moment != img.moment
                    );
                    this.info.photos = this.info.photos.filter(
                        (item) => item.moment != img.moment
                    );
                } else {
                    this.attachment.items = this.attachment.items.filter(
                        (item) => item.id != img.id
                    );
                    this.$store.dispatch("SafetyAppController/deleteAttachments", {
                        ids: [img.id]
                    }).then(() => {
                        this.$emit("reloadItem");
                    })
                }
            },
            resetAttachment() {
                this.attachment.items = []
            },
            changeProject() {
                this.info.equipment = null;
                // this.info.locations = [];
                this.info.supplier = null;
                // this.info.contractor_supervisor_by = null;
                this.info.property_manager_by = null;
                this.info.safety_officer_by = null;
            }
        }
    }
</script>
<style lang="scss">
    .tooltip {
        max-width: 400px;
    }
</style>